function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment-success_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.957.103a1.585 1.585 0 011.57 1.339l.015.145V3.53h-9.6a3.05 3.05 0 00-2.206.814 3.025 3.025 0 00-.951 1.935l-.012.202v7.766a3.035 3.035 0 002.927 2.95l.178.002h9.6v1.941a1.58 1.58 0 01-1.438 1.477l-.146.007H1.584a1.584 1.584 0 01-1.569-1.339L0 19.14V1.587A1.582 1.582 0 011.438.11l.146-.007h20.373zm2.076 5.13a1.285 1.285 0 011.303 1.103l.012.144v7.766a1.277 1.277 0 01-1.17 1.242l-.145.005H13.878a1.285 1.285 0 01-1.303-1.102l-.012-.145V6.48a1.276 1.276 0 011.17-1.242l.145-.005h10.155zm-5.16 1.127a3.787 3.787 0 10.002 7.574 3.787 3.787 0 00-.003-7.574zm.247 2.26a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
  fill: "url(#payment-success_svg__a)",
  fillRule: "nonzero"
});

function SvgPaymentSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21
  }, props), _ref, _ref2);
}

export default SvgPaymentSuccess;